export default __webpack_public_path__ + "static/media/codicon.b3726f01.ttf";